<div class="page-wrapper pt-4">
    <div class="page-content pt-0 pe-0 ps-0">
        <div class="container-fluid">
            <div class="default_class">
                <div class="content-wrapper p-0">
                    <div class="container-fluid">
                        <div class="row">
                            <div class="col-xl-12" *ngIf="!isView">
                                <div class="card rounded shadow-lg">
                                    <div class="card-header  headerbg" style="border-bottom:3px solid #d8eff8;">
                                        <h5 class="mb-0 ">Start-up</h5>
                                        <div class="text-right">
                                            <button type="button" class="btn btn-primary mb-1"
                                                (click)="add()">Add</button>
                                        </div>
                                    </div>
                                    <div class="card-body">
                                        <div *ngIf="listGrid.length">
                                            <table id="patreggraph" datatable
                                                class=" table-striped table-bordered mt-2 pt-2 table-sm small"
                                                style="width:100%">
                                                <thead class="top" style="background-color: #2e7a91; color:#ffffff;">
                                                    <tr>
                                                        <th>S. No</th>
                                                        <th> User Name </th>
                                                        <th> Email Id </th>
                                                        <th> Contact No. </th>
                                                        <th> Incubator Status </th>
                                                        <th> Investor Status </th>
                                                        <th> Approved / Reject Date </th>
                                                        <!-- <th> Rejected date </th> -->
                                                        <th> Action </th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr *ngFor="let item of listGrid; let i= index">
                                                        <td>{{i+1}}</td>
                                                        <td>{{item.userName}}</td>
                                                        <td>{{item.email_id}}</td>
                                                        <td>{{item.mobile_no}}</td>
                                                        <td>{{item.application_status == '2' ? 'Approve':
                                                            (item.application_status == '3' ? 'Reject': 'Pending')}}
                                                        </td>
                                                        <td>{{item.investor_status == '2' ? 'Approve':
                                                            (item.investor_status == '3' ? 'Reject': 'Pending')}}</td>
                                                        <td>{{item.created_at | date: 'dd-MM-yyyy'}}</td>
                                                        <!-- <td>{{item.rejected_at | date: 'dd-MM-yyyy'}}</td> -->
                                                        <button class="btn btn-primary btn-sm text-center m-1"
                                                            (click)="OnEditView(item, 'view')">
                                                            View</button>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                        <div class="text-center" *ngIf="!listGrid.length">
                                            No Records to display
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-xl-12" *ngIf="isView">
                                <app-startup-profile [childData]="parentMessage"
                                    [parentUser]="parentUser"></app-startup-profile>
                                <button class="btn btn-sm btn-success" (click)="Close()"><i
                                        class="bi bi-arrow-left-circle fa-2x"></i> </button>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>
</div>